import React, { useEffect, useState } from 'react';
import { Typography } from '@totango-app-team/ui-shared-components';
import classNames from 'classnames';

import TotangoAnimateLogo from 'Components/icons/logo/totango-logo-animate';
import useMobileDetect from 'Hooks/useMobileDetect';

import './create-service-loader.less';
import './signup-followup-details.less';

const MESSAGES_CONTENT = [
	{
		text: ' Adding a few finishing touches...',
		emoji: '✨',
		labelledby: 'sparkles',
	},
	{
		text: ' Adding some more customer impact…',
		emoji: '💪',
		labelledby: 'muscle',
	},
	{
		text: ' Putting finishing touches of awesomeness…',
		emoji: '🙌',
		labelledby: 'raised_hands',
	},
];

const { searchParams } = new URL(window.location.href);
const useLongSignup = searchParams.get('long_signup') !== null;
const CreateServiceLoader = ({ style }) => {
	const [contentIndex, setContentIndex] = useState(0);
	const [isTakingLong, setIsTakingLong] = useState(false);
	const { isDesktop } = useMobileDetect();

	useEffect(() => {
		const interval = setInterval(() => {
			setContentIndex(prevIndex => (prevIndex + 1) % MESSAGES_CONTENT.length);
		}, 3000);
		const timeout = setTimeout(() => {
			clearInterval(interval);
			setIsTakingLong(true);
		}, 120000); //2 minutes
		return () => {
			clearTimeout(timeout);
			clearInterval(interval);
		};
	}, []);
	return (
		<>
			{!useLongSignup && isDesktop() ? (
				<div style={style} className="short-signup-loading-container">
					<div className={classNames('signup-followup-details-modal', 'signup-loading')}>
						<div className={classNames('confirmation-dialog-paper', 'signup-window')}>
							<div className="header">
								<img
									src="/img/logo/totango-dark.png"
									height="26"
									className="hidden-sm hidden-xs"
									alt="Totango"
								/>
							</div>
							<div className="signup-success-caption" align="center">
								{isTakingLong ? (
									<Typography variant="h4">
										{'The creation of your account is taking longer than expected.'}
										<br />
										{
											'We will email you once your account is ready, or you can click on your email link any time to come back to this page'
										}
									</Typography>
								) : (
									<Typography variant="h4">
										<span
											className="emoji-logo"
											role="img"
											aria-labelledby={MESSAGES_CONTENT[contentIndex].labelledby}
										>
											{MESSAGES_CONTENT[contentIndex].emoji}
										</span>
										{`${MESSAGES_CONTENT[contentIndex].text}`}
									</Typography>
								)}
							</div>
							<div className="totango-logo">
								<TotangoAnimateLogo />
							</div>
						</div>
					</div>
				</div>
			) : (
				<div className="legacy-signup-loading">
					<div className="signup-success-caption" align="center">
						{isTakingLong ? (
							<>
								{'The creation of your account is taking longer than expected.'}
								<br />
								{
									'We will email you once your account is ready, or you can click on your email link any time to come back to this page'
								}
							</>
						) : (
							<>
								<span
									className="emoji-logo"
									role="img"
									aria-labelledby={MESSAGES_CONTENT[contentIndex].labelledby}
								>
									{MESSAGES_CONTENT[contentIndex].emoji}
								</span>
								{`${MESSAGES_CONTENT[contentIndex].text}`}
							</>
						)}
					</div>
					<div className="totango-logo">
						<TotangoAnimateLogo />
					</div>
				</div>
			)}
		</>
	);
};

export default CreateServiceLoader;
